<template>
    <div class="text-center">
        <img src="../assets/images/account/delete_account.svg" class="pic">
        <div class="big-no">404</div>
        <div>找不到頁面</div>

    </div>
</template>

<script>

    export default {
        name: "404",
        data() {
            return {}
        },
    }
</script>

<style scoped lang="less">
    .pic{
        width: 150px;
        margin: 100px auto 0;
    }
    .big-no{
        font-size: 100px;
        font-weight: 500;
        line-height: 100px;
        margin: 10px 0 0;
    }
</style>
